/* eslint-disable */
import React, { memo, useEffect, useRef, useState } from "react";
import * as API from "../../framework/API/api";
import moment from "moment";
import { ACCESS_LEVEL, ASSETTYPE, ASSURANCETYPE, ENTITYNAME, LOCALSTORAGE_KEY, MEDIACATEGORIES, OTTROUTETYPE, PUBLISHING_SOURCE, TOAST_TYPES } from "../../framework/constant/constant";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import ContractCollectionSelection from "../Contract/ContractCollectionSelection";
import { useTranslation } from "../../locale/useTranslation";
import { DropdownWithDefaultValue } from "../../framework/forms/helpercomponents/dropdown/DropdownWithDefaultValue";
import { utility } from "../../framework/utility/utilityProvider";
import { Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";
import JobsShowForm from "../IngestionTemplate/JobsShowForm";
import { collectionJobsMenuModel } from "../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel";
import { Collection } from "../../framework/forms/Collection";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import OttAssetVideoEditForm from "./OttAssetVideoEditForm";
import OttAssetPosterEditForm from "./OttAssetPosterEditForm";
import InfoRoundButton from "../../components/InfoRoundButton";
import BossDialog from "../../components/BossDialog";
import MultiLangInput from "../../framework/forms/helpercomponents/inputs/MultiLangInput";
import OttSubtitleForm from "./OttSubtitleForm";
import MediaEpisodePublishingEditForm from "./MediaEpisodePublishingEditForm";
import ToastNotification from "../../components/ToastNotification";

const MediaEpisodeAssetEditForm = (props) => {

  const navigate = useNavigate();
  const Company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  let showPublishingTab = props?.showPublishingTab ?? false;

  const [ottTabNumber, setOttTabNumber] = React.useState("1");
  const [ottAssetVideos, setOttAssetVideos] = useState(props.dataItem.Videos ?? []);
  const [ottAssetPosters, setOttAssetPosters] = useState(props.dataItem.Posters ?? []);
  const [ottSubtitleData, setOttSubtitleData] = useState(props?.dataItem?.SubTitles ?? []);

  const getWebAssetsData = async (value) => {
    let webAssetsRes = await API.getData(ENTITYNAME.WebAssets, { query: ["_id", "=", value] });
    return webAssetsRes?.data?.length > 0 ? webAssetsRes?.data[0] : {};
  }

  const [dataItem, setDataItem] = useState({
    _id: props.dataItem._id ?? null,
    SID: props.dataItem.SID ?? 0,
    OttAssetTypeSID: props.source == 'self' ? ASSETTYPE.Live : ASSETTYPE["Media Asset"],

    //OLD
    // Title: props.dataItem.Title ?? '',
    // Description: props.dataItem.Description ?? '',

    Title: props.dataItem.Title ?? [],
    Description: props.dataItem.Description ?? [],

    VideoPlaybackUrl: props.dataItem.VideoPlaybackUrl ?? '',
    // routeType: props.dataItem.routeType ?? OTTROUTETYPE.Player, // DEFAULT
    routeType: props.dataItem.routeType,
    StartDate: props.dataItem.StartDate ?? moment(new Date()).format("YYYY-MM-DD"),
    EndDate: props.dataItem.EndDate ?? moment(new Date()).add(1, 'M').format("YYYY-MM-DD"),
    page_id: props.dataItem.page_id ?? '',
    Archive: props.dataItem.Archive ?? false,
    TBA: props.dataItem.TBA ?? false,
    Source: props.dataItem.Source ?? {},
    IsOttAsset: props.dataItem.IsOttAsset ?? false,
    VodTypes: props.dataItem.VodTypes && props.dataItem.VodTypes.length > 0 ? props.dataItem.VodTypes[0] : {},
    Videos: props.dataItem.Videos ?? [],
    Posters: props.dataItem.Posters ?? [],
    Segments: props.dataItem.Segments ?? [],
    Playlist: props?.dataItem?.Playlist ?? "",
    SubTitles: props?.dataItem?.SubTitles ?? [],
    thumbnailUrl: props.dataItem.thumbnailUrl ?? '',
  });

  const [startTime, setStartTime] = useState("");
  const [ottAssetType, setOttAssetType] = useState([]);
  const [ottPage, setOttPage] = useState([]);
  const [vodTypes, setVodTypes] = useState([]);
  const [providers, setProviders] = useState([]);
  let providersRef = useRef([]);

  const [routeTypes, setRouteTypes] = useState([]);
  const [jobsCollectionOpen, setJobsCollectionOpen] = useState(false);
  const [showWebAssets, setShowWebAssets] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(props.sourceEntity ? props.sourceEntity : {});
  const [source, setSource] = useState('');
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [isAssetTypeText, setIsAssetTypeText] = useState(props?.dataItem?.OttAssetTypeSID == ASSETTYPE.Text ? true : false);
  const [showJobCollection, setShowJobCollection] = useState(false);
  const lang = useTranslation();
  const [posterDimensionPageOpen, setPosterDimensionPageOpen] = useState(false);
  const [accessLevels, setAccessLevels] = useState([]);
  const [segments, setSegments] = useState(props.dataItem.Segments ?? []);
  const [musicOpen, setMusicOpen] = useState(false);
  const [musicPlaylists, setMusicPlaylists] = useState([]);
  const [openMusicPlaylist, setOpenMusicPlaylist] = useState(false);
  const [openPublishingDialog, setOpenPublishingDialog] = useState(false);
  const [defaultDealRight, setDefaultDealRight] = useState({});
  const [publishingDialogTitle, setPublishingDialogTitle] = useState(null);

  const offerRef = useRef()
  const [offers, _setOffers] = useState([]);
  const setOffers = (data) => {
    offerRef.current = data;
    _setOffers(data)
  }

  useEffect(() => {
    pageRender()
  }, [])

  const pageRender = async () => {
    await loadcombo();
    await setEditItem();
  }

  const loadcombo = async () => {

    const ottAssetType = Object.keys(ASSETTYPE).map((item) => ({
      Description: item,
      ID: ASSETTYPE[item]
    }));
    setOttAssetType(ottAssetType);
    let selectedAssetTypeId = dataItem?.OttAssetTypeSID?.ID;

    let rolesTypes = Object.keys(OTTROUTETYPE).map((item) => ({
      Description: item,
      ID: OTTROUTETYPE[item]
    }));
    if (selectedAssetTypeId === ASSETTYPE.Music) {
      rolesTypes = rolesTypes.filter(
        (item) =>
          item.ID === OTTROUTETYPE.MusicPlayer ||
          item.ID === OTTROUTETYPE.MusicPlaylist
      );
    } else {
      rolesTypes = rolesTypes.filter(
        (item) =>
          item.ID !== OTTROUTETYPE.MusicPlayer &&
          item.ID !== OTTROUTETYPE.MusicPlaylist
      );
    }
    setRouteTypes(rolesTypes);

    //HANDLE HERE
    let ottPageLocal = await API.getData(ENTITYNAME.Page, { query: ['Archive', '=', false] });
    setOttPage(utility.getDataWithDisplayValueByLang(ottPageLocal.data, ['Name', 'DisplayName'], props.selectedLanguage));

    let vodtypes = await API.getData(ENTITYNAME.VODType);
    setVodTypes(vodtypes.data);

    let providerRes = await API.getDataLookup(ENTITYNAME.OttProvider, { query: ['Archive', '=', false] });
    providersRef.current = providerRes.data;
    setProviders(providerRes.data);

    let accessLevelRes = Object.keys(ACCESS_LEVEL).map((item) => {
      return { _id: ACCESS_LEVEL[item], Description: item }
    })
    setAccessLevels(accessLevelRes);

    let segmentsRes = await API.getDataLookup(ENTITYNAME.OttSegment, { query: ["Archive", '=', false], sort: { Description: 1 } });
    setSegments(segmentsRes.data);

    let musicPlaylistRes = await API.getDataLookup(ENTITYNAME.MusicPlaylist, { query: ["Archive", "=", false] });
    setMusicPlaylists(musicPlaylistRes.data);

    let offerRes = await API.getDataLookup(ENTITYNAME.OFFER, { sort: { SID: 1 } });
    setOffers(offerRes.data)

  }

  const setEditItem = async () => {
    let res = {};
    let isOttAsset = false;

    if (props.source !== 'self' && Object.keys(props.dataItem).length === 0) {
      res = await API.getData(props.entityname, {
        query: [
          ['Source._id', '=', props.sourceEntity._id],
          ['Source.entityName', '=', props.source]
        ]
      });
      isOttAsset = props.sourceEntity.IsOttAsset;
    } else {
      res = { data: [props.dataItem] };
      isOttAsset = props.dataItem?.IsOttAsset ?? false;
    }

    if (res.data.length === 0) {
      res = { data: [dataItem] };
    }

    const asset = res.data[0];

    if (asset?.routeType === OTTROUTETYPE.Page) setShowVideoPlayer(true);
    if (asset?.routeType === OTTROUTETYPE.MusicPlaylist) setOpenMusicPlaylist(true);

    props.setDataEntity?.({
      ...asset,
      VodTypes: Array.isArray(asset?.VodTypes)
        ? asset.VodTypes[0] ?? {}
        : asset.VodTypes ?? {},
      WebAssets: Array.isArray(asset?.WebAssets) && asset.WebAssets.length > 0
        ? await getWebAssetsData(asset.WebAssets)
        : {},
      IsOttAsset: isOttAsset
    });

    const getaccessLevelData = Object.keys(ACCESS_LEVEL).map((key, index) => ({
      _id: index,
      Description: key
    }));

    let dataItemLocal = {};

    if (res.data.length > 0) {
      dataItemLocal = {
        ...asset,
        SID: asset.copy ? 0 : asset.SID,
        Title: Array.isArray(asset.Title)
          ? asset.Title
          : [{ langISO: Company.Language.ISOCode, value: asset.Title }],
        Description: Array.isArray(asset.Description)
          ? asset.Description
          : [{ langISO: Company.Language.ISOCode, value: asset.Description }],
        StartDate: asset.StartDate
          ? moment(new Date(asset.StartDate)).format('YYYY-MM-DD')
          : moment(new Date()).format('YYYY-MM-DD'),
        EndDate: asset.EndDate
          ? moment(new Date(asset.EndDate)).format('YYYY-MM-DD')
          : moment(new Date()).add(1, 'M').format('YYYY-MM-DD'),
        TBA: asset.TBA,
        VideoPlaybackUrl: asset.VideoPlaybackUrl,
        OttAssetTypeSID: asset.OttAssetTypeSID ?? 1,
        Source: asset.Source ?? {},
        routeType: asset.routeType,
        page_id: asset.page_id ?? '',
        IsOttAsset: isOttAsset,
        VodTypes: Array.isArray(asset?.VodTypes)
          ? asset.VodTypes[0] ?? {}
          : asset.VodTypes ?? {},
        Playlist: asset.Playlist ?? '',
        Videos:
          Array.isArray(asset?.Videos) && asset.Videos[0]?.langISO
            ? asset.Videos
            : [{ langISO: Company.Language.ISOCode, value: asset.Videos }],
        Posters:
          Array.isArray(asset?.Posters) && asset.Posters[0]?.langISO
            ? asset.Posters
            : [{ langISO: Company.Language.ISOCode, value: asset.Posters }],
        RentalRetailPrice: asset.RentalRetailPrice ?? '',
        RentalWholesalePrice: asset.RentalWholesalePrice ?? '',
        accessLevel:
          getaccessLevelData.find((x) => x._id === asset.accessLevel) ??
          {
            _id: ACCESS_LEVEL.Both,
            Description: utility.getKeyByValue(ACCESS_LEVEL, ACCESS_LEVEL.Both)
          },
        WebAssets:
          Array.isArray(asset?.WebAssets) && asset.WebAssets.length > 0
            ? await getWebAssetsData(asset.WebAssets)
            : {},
        Provider: asset.Provider
          ? providersRef.current?.find((x) =>
            x?._id === (asset.Provider?._id ?? asset.Provider)
          )
          : utility.getDefaultItem(providersRef.current),
        SubTitles: asset?.SubTitles ?? [],
        thumbnailUrl: asset?.thumbnailUrl
      };

      setStartTime(utility.parseAdjust(asset.StartDate));
      setSelectedMedia(asset.Source ?? {});
      setOttAssetVideos(dataItemLocal.Videos ?? []);
      setOttAssetPosters(dataItemLocal.Posters ?? []);
      setOttSubtitleData(dataItemLocal?.SubTitles ?? [])
    }
    setDataItem(dataItemLocal);

    const selectedAssetTypeId = dataItemLocal?.OttAssetTypeSID?.ID ?? dataItemLocal?.OttAssetTypeSID;

    let filteredRouteTypes = Object.keys(OTTROUTETYPE).map((item) => ({
      Description: item,
      ID: OTTROUTETYPE[item]
    }));

    if (selectedAssetTypeId === ASSETTYPE.Music) {
      filteredRouteTypes = filteredRouteTypes.filter(
        (item) =>
          item.ID === OTTROUTETYPE.MusicPlayer ||
          item.ID === OTTROUTETYPE.MusicPlaylist
      );
    } else {
      filteredRouteTypes = filteredRouteTypes.filter(
        (item) =>
          item.ID !== OTTROUTETYPE.MusicPlayer &&
          item.ID !== OTTROUTETYPE.MusicPlaylist
      );
    }

    if (dataItemLocal?.OttAssetTypeSID === ASSETTYPE["Media Asset"]) {
      const srcDesc =
        dataItemLocal?.Source?.Description ??
        dataItemLocal?.Source?.MediaCategory?.Description;

      if (srcDesc === "Series" || srcDesc === "Season") {
        dataItemLocal = {
          ...dataItemLocal,
          routeType: OTTROUTETYPE.PiPage,
          routeTypeDisabled: true,
        };
      }

      if (dataItemLocal?.Source?._id) {

        let mediaDealRights = await API.getData(ENTITYNAME.MediaDealRights, { query: ["media_id", "=", dataItemLocal.Source._id.toString()] });

        let tempDealRightsData = mediaDealRights.data ?? [];
        if (mediaDealRights.data.length > 0) {
          tempDealRightsData = mediaDealRights.data.map((obj, index) => { return { ...obj, index: index } })
        }
        props.setMediaEpisodePublishings(tempDealRightsData ?? []);

        // Load Offer
        await loadOffer(dataItemLocal.Source);
      }

    }

    setRouteTypes(filteredRouteTypes);
    setShowForm(true);
  };

  const loadOffer = async (entity = {}) => {
    let offerDataRes = await API.getAssetsOfferLink({ query: ["media_id", "=", entity?._id?.toString()] });
    props.setMediaEpisodeOffers && props.setMediaEpisodeOffers(offerDataRes?.data ?? []);
  }

  const handleMediaSelect = (dataList, src) => {
    const selected = dataList[0];
    setSelectedMedia(selected);
    setSource(src);

    let tempSource = src;
    if (src.Description !== "Series" && src.Description !== "Season") { tempSource = { Description: "mediaepisode" }; }

    let updatedData = {
      ...dataItem,
      Title: selected.Title,
      Description: selected.Title,
      Source: {
        _id: selected._id,
        SID: selected.SID,
        Title: selected.Title,
        MediaCategory: selected.MediaCategory,
        entityName: tempSource.Description.toLowerCase(),
      },
    };
    if (OttAssetTypeSID === ASSETTYPE["Media Asset"]) {
      if (src.Description === "Series" || src.Description === "Season") {
        updatedData = { ...updatedData, routeType: OTTROUTETYPE.PiPage, routeTypeDisabled: true };
      } else {
        updatedData = { ...updatedData, routeType: dataItem.routeType, routeTypeDisabled: false };
      }
    }
    setDataItem(updatedData);
    props.setDataEntity(updatedData);
  };

  const onChangeForm = (e) => {
    const { name, value } = e.target;

    if (name === "OttAssetTypeSID") {
      const selectedAssetType = value;
      const selectedAssetTypeId = selectedAssetType.ID;

      // Filter valid route types based on selected asset type
      const filteredRoutes = Object.keys(OTTROUTETYPE).map((item) => ({
        Description: item,
        ID: OTTROUTETYPE[item]
      })).filter((item) => {
        if (selectedAssetTypeId === ASSETTYPE.Music) {
          return item?.ID === OTTROUTETYPE.MusicPlayer || item?.ID === OTTROUTETYPE.MusicPlaylist;
        } else {
          return item?.ID !== OTTROUTETYPE.MusicPlayer && item?.ID !== OTTROUTETYPE.MusicPlaylist;
        }
      });

      setRouteTypes(filteredRoutes);
      let newRouteType = "";
      let currentRouteID = typeof dataItem.routeType === 'object' && dataItem.routeType !== null ? (dataItem.routeType.ID || dataItem.routeType._id || dataItem.routeType.value) : dataItem.routeType;
      if (selectedAssetTypeId === ASSETTYPE.Web) {
        newRouteType = OTTROUTETYPE.WebView;
      } else if (currentRouteID && filteredRoutes.some(r => r.ID == currentRouteID)) {
        newRouteType = dataItem.routeType;
      }
      const updatedData = {
        ...dataItem,
        OttAssetTypeSID: selectedAssetType,
        Title: [],
        Description: [],
        VideoPlaybackUrl: '',
        routeType: newRouteType,
        StartDate: moment().format("YYYY-MM-DD"),
        EndDate: moment().add(1, 'M').format("YYYY-MM-DD"),
        page_id: '',
        Archive: false,
        TBA: false,
        Source: {},
        IsOttAsset: false,
        VodTypes: {},
        Segments: [],
        Playlist: ''
      };

      setSelectedMedia({ Title: "" });
      setIsAssetTypeText(selectedAssetTypeId === ASSETTYPE.Text);
      setOpenMusicPlaylist(false);
      setShowVideoPlayer(false);

      setDataItem(updatedData);
      props.setDataEntity(updatedData);
    }

    else if (name === "Archive") {
      const updatedValue = !dataItem.Archive;
      setDataItem({ ...dataItem, Archive: updatedValue });
      props.setDataEntity({ ...dataItem, Archive: updatedValue });
    }

    else if (name === "TBA") {
      const updatedValue = !dataItem.TBA;
      setDataItem({ ...dataItem, TBA: updatedValue });
      props.setDataEntity({ ...dataItem, TBA: updatedValue });
    }

    else if (name === "routeType") {
      const selectedRoute = value;
      let updatedData = { ...dataItem, routeType: selectedRoute };

      if (selectedRoute.ID === OTTROUTETYPE.Page) {
        setShowVideoPlayer(true);
      } else if (selectedRoute.ID === OTTROUTETYPE.MusicPlaylist) {
        setOpenMusicPlaylist(true);
      } else {
        setShowVideoPlayer(false);
        setOpenMusicPlaylist(false);
        updatedData.page_id = "";
        updatedData.Playlist = "";
      }

      setDataItem(updatedData);
      props.setDataEntity(updatedData);
    }

    else if (name === "StartDate") {
      setStartTime(value);
      setDataItem({ ...dataItem, StartDate: value });
      props.setDataEntity({ ...dataItem, StartDate: value });
    }

    else if (name === "Segments") {
      setDataItem({ ...dataItem, Segments: value });
      props.setDataEntity({ ...dataItem, Segments: value });
    }

    else {
      setDataItem({ ...dataItem, [name]: value });
      props.setDataEntity({ ...dataItem, [name]: value });
    }
  };
  const onSwitchChange = (e) => {
    setDataItem({ ...dataItem, IsOttAsset: e.target.checked });
    props.setDataEntity({ ...dataItem, IsOttAsset: e.target.checked });
  }

  const openMedia = (e) => {
    e.preventDefault();
    if (selectedMedia && selectedMedia.SID && selectedMedia.MediaCategory?.Description) {
      window.open(`/home/MediaEpisode/${selectedMedia.MediaCategory.Description}/${selectedMedia?.SID}`);
    } else {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `Select Media` });
    }
  };
  const deleteSelectedMedia = () => {
    setSelectedMedia({ Title: "" });
    props.setDataEntity({ ...dataItem, Source: {} })
  }

  const handleAssetsTabChange = (event, newValue) => {
    setOttTabNumber(`${newValue}`);
  };

  const setOttVideosData = (videos) => {
    setOttAssetVideos(videos);
    setDataItem({ ...dataItem, Videos: videos, Posters: ottAssetPosters });
    props.setDataEntity({ ...dataItem, Videos: videos, Posters: ottAssetPosters });

  }
  const setOttPostersData = (data) => {
    setOttAssetPosters(data);
    setDataItem({ ...dataItem, Posters: data, Videos: ottAssetVideos });
    props.setDataEntity({ ...dataItem, Posters: data, Videos: ottAssetVideos });
  }

  const handleJobData = (data) => {
    setDataItem({ ...dataItem, VideoPlaybackUrl: data[0].HlsUrl });
    props.setDataEntity({ ...dataItem, VideoPlaybackUrl: data[0].HlsUrl });
  }

  const onClosedPosterDimensionPage = async () => {
    setPosterDimensionPageOpen(false);
  }

  const handleSeletedWebAssets = (data) => {
    setDataItem({ ...dataItem, WebAssets: data[0] });
    props.setDataEntity({ ...dataItem, WebAssets: data[0] });
  }

  const handleSubtitle = (data) => {
    setOttSubtitleData(data);
    setDataItem({ ...dataItem, SubTitles: data });
    props.setDataEntity({ ...dataItem, SubTitles: data });

  }

  const handleMediaPublishingData = (data) => {
    props.setMediaEpisodePublishings(data);
    setPublishingDialogTitle(null);
  }

  const handleMediaOfferData = (data) => {
    props.setMediaEpisodeOffers(data);
  }

  const handleRemovePublishingData = (removedDataItem) => {
    props.setRemovedMedia(old => [...old, removedDataItem]);
  }

  const handleRemoveOfferData = (removedDataItem) => {
    props.setRemovedOffers(old => [...old, removedDataItem]);
  }

  const OttAssetTypeSID = typeof dataItem.OttAssetTypeSID == 'number' ? dataItem.OttAssetTypeSID : dataItem.OttAssetTypeSID.ID;
  const isMusic = props.source == 'self' && OttAssetTypeSID == ASSETTYPE.Music;

  return (
    <>
      <div className="col-12">
        {props.source != 'self' && <>
          <div className="row">
            <div className="col-6">
              <label htmlFor=""><h3 style={{ margin: '0px' }}>{lang.create_ott_asset_label}</h3></label>
              <Switch checked={dataItem.IsOttAsset} onChange={onSwitchChange} />
            </div>
            {dataItem.IsOttAsset && <div className="col-6 text-right">
              <button type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success"
                style={{ height: "30px" }} onClick={() => setJobsCollectionOpen(true)}>
                {lang.show_jobs_button_text}
              </button>
            </div>}
          </div>
        </>}

        {(props.source == 'self' || dataItem.IsOttAsset) && <>
          <div className="row">
            <div className={props.source != 'self' ? 'col-6 mt-2' : isAssetTypeText ? 'col-12 mt-2' : 'col-6 mt-2'}>
              <label htmlFor="">{lang.asset_type_label} *</label>
              <InfoRoundButton message={lang.show_poster_dimension_title_label} onClick={(e) => { setPosterDimensionPageOpen(true); }}></InfoRoundButton>
              <DropdownWithDefaultValue
                name={"OttAssetTypeSID"}
                textField={"Description"}
                value={dataItem.OttAssetTypeSID}
                data={ottAssetType}
                datakey={"ID"}
                onChange={onChangeForm}
                disabled={props.source != 'self'}
              />
            </div>

            {!isAssetTypeText && <div className="col-6 mt-2">
              <label htmlFor="">{lang.vodtype_label} *</label>
              <DropDownList
                style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                data={vodTypes}
                name={"VodTypes"}
                textField="Name"
                dataItemKey="_id"
                value={dataItem.VodTypes}
                onChange={onChangeForm}
              />

            </div>}
            {dataItem.VodTypes.Name == "TVOD" && <div className="col-6 mt-2">
              <label htmlFor="">{lang.rental_retail_price_label}</label>
              <input name={"RentalRetailPrice"} className="form-control form-control-sm" type={'number'} value={dataItem.RentalRetailPrice} onChange={onChangeForm} />
            </div>
            }

            {dataItem.VodTypes.Name == "TVOD" && <div className="col-6 mt-2">
              <label htmlFor="">{lang.rental_wholesale_price_label}</label>
              <input name={"RentalWholesalePrice"} className="form-control form-control-sm" type={'number'} value={dataItem.RentalWholesalePrice} onChange={onChangeForm} />
            </div>
            }

            {props.source == 'self' && OttAssetTypeSID != ASSETTYPE["Media Asset"] && OttAssetTypeSID != ASSETTYPE["Music"] && <div className="col-12 mt-2">
              <MultiLangInput
                name="Title"
                label={lang.title_label}
                dataItem={dataItem}
                selectedLanguage={props.selectedLanguage}
                setDataItem={(item) => {
                  setDataItem(item);
                  props.setDataEntity(item)
                }
                }
              />
            </div>}

            {/* NEED TO ASK */}
            {(isMusic || (props.source === 'self' && OttAssetTypeSID === ASSETTYPE["Media Asset"])) && (
              <>
                <div className="col-10 mt-2" >
                  <label htmlFor="">{isMusic ? lang.music_label : lang.media_label}</label>
                  <input
                    name={"Media"}
                    className="form-control form-control-sm"
                    type={'text'}
                    value={selectedMedia.Title}
                    disabled={true}
                    onChange={() => ""}
                  />
                </div>

                <button type="button" className="ml-2 k-button k-button-md k-rounded-md k-button-solid k-button-solid-success"
                  style={{ height: "30px", marginTop: "28px" }} onClick={(e) => { e.preventDefault(); isMusic ? setMusicOpen(true) : setMediaOpen(true); }}>
                  {'...'}
                </button>
                <button type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-warning"
                  style={{ height: "30px", marginTop: "28px", marginLeft: '3px' }} onClick={openMedia}>
                  <i className="fa-solid fa-eye"></i>
                </button>
                <button type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-info"
                  style={{ height: "30px", marginTop: "28px", marginLeft: '3px' }} onClick={(e) => { deleteSelectedMedia(); e.preventDefault() }}>
                  <i className="fa-solid fa-trash"></i>
                </button>
              </>
            )}
            <div className="col-12 mt-2" >
              <div className="form-group">
                <MultiLangInput
                  name="Description"
                  label={lang.description_label}
                  dataItem={dataItem}
                  selectedLanguage={props.selectedLanguage}
                  setDataItem={(item) => {
                    setDataItem(item);
                    props.setDataEntity(item)
                  }
                  }
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label htmlFor="">{lang.access_level_label} *</label>
              <DropDownList
                data={accessLevels}
                style={{ backgroundColor: 'white' }}
                name="accessLevel"
                textField="Description"
                dataItemKey="_id"
                value={dataItem.accessLevel}
                onChange={onChangeForm}
              />
            </div>
            <div className="col-6">
              <label htmlFor="">{lang.provider_label}</label>
              <DropDownList
                style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                data={providers}
                name={"Provider"}
                textField="Description"
                dataItemKey="_id"
                value={dataItem.Provider}
                onChange={onChangeForm}
              />
            </div>

          </div>
          <div className="row mt-2">
            {!isAssetTypeText && <div className="col-6">
              <label htmlFor="">{lang.route_type_label} *</label>
              <DropdownWithDefaultValue
                name={"routeType"}
                textField={"Description"}
                value={dataItem.routeType}
                data={routeTypes}
                datakey={"ID"}
                onChange={onChangeForm}
                disabled={OttAssetTypeSID == ASSETTYPE.Web || dataItem.routeTypeDisabled}
              />
            </div>}

            <div className="col-6">
              <label htmlFor="TabView">{lang.segment_label} </label><span className="float-right" style={{ fontSize: "10px" }}>Note: If Segment not select by default all</span>
              <MultiSelect
                style={{
                  backgroundColor: "white",
                }}
                data={segments}
                name={"Segments"}
                textField={"Description"}
                dataItemKey={"_id"}
                value={dataItem.Segments}
                onChange={onChangeForm}
              />
            </div>

            {openMusicPlaylist && (
              <div className="col-6 mt-1">
                <label>{lang.playlist_label} *</label>
                <DropDownList
                  data={musicPlaylists}
                  textField="Description"
                  dataItemKey="_id"
                  name="Playlist"
                  value={dataItem.Playlist}
                  onChange={onChangeForm}
                />
              </div>
            )}

            {showVideoPlayer && <div className="col-6">
              <label htmlFor="">{lang.page_label} *</label>
              <DropdownWithDefaultValue
                name={"page_id"}
                textField={"Name"}
                value={dataItem.page_id}
                datakey={"_id"}
                data={ottPage}
                onChange={onChangeForm}
              />
            </div>}
            {OttAssetTypeSID == ASSETTYPE.Web && <>
              <div className="col-5" >
                <label htmlFor="">{lang.web_assets_label} *</label>
                <input
                  name={"WebAssets"}
                  className="form-control form-control-sm"
                  type={'text'}
                  value={dataItem?.WebAssets?.Name}
                  disabled={true}
                  onChange={() => ""}
                />
              </div>
              <div className="col-1">
                <button type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success"
                  style={{ height: "29px", marginTop: "20px" }} onClick={(e) => { setShowWebAssets(true); e.preventDefault(); }}>
                  {'...'}
                </button>
              </div> </>}
          </div>

          <div className="row mt-2">
            <div className="col-6" >
              <label htmlFor="">{lang.thumbnail_url_label}</label>
              <input
                name="thumbnailUrl"
                className="form-control form-control-sm"
                type='text'
                value={dataItem?.thumbnailUrl}
                onChange={onChangeForm}
              />
            </div>
            <div className='col mt-4'>
              <input name={"Archive"} type={'checkbox'} onChange={onChangeForm} value={dataItem.Archive} checked={dataItem.Archive} style={{ margin: '0px 5px 0px 2px' }} />
              <label htmlFor="">{lang.archive}</label>
            </div>
          </div>

          {/* VIDEO AND POSTER TABS */}

          {!isAssetTypeText && <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
              <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={ottTabNumber}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleAssetsTabChange} aria-label="lab API tabs example">
                      <Tab label={lang.ott_assets_video} value="1" />
                      <Tab label={lang.ott_assets_poster} value="2" />
                      <Tab label={lang.ott_subtitle_label} value="3" />
                      {showPublishingTab && OttAssetTypeSID == ASSETTYPE["Media Asset"] && <Tab label={lang.publishing_label} value="4" />}

                      {/* {OttAssetTypeSID == ASSETTYPE["Media Asset"] && selectedMedia && selectedMedia.MediaCategory && selectedMedia.MediaCategory.isLong && <Tab label={lang.publishing_label} value="4" />} */}
                    </TabList>
                  </Box>
                  <TabPanel value={"1"} style={{ marginLeft: -30, marginRight: -30, marginBottom: -10 }}>
                    <OttAssetVideoEditForm data={ottAssetVideos} setOttVideosData={setOttVideosData} selectedLanguage={props.selectedLanguage} />
                  </TabPanel>
                  <TabPanel value={"2"} style={{ marginLeft: -30, marginRight: -30, marginBottom: -10 }}>
                    <OttAssetPosterEditForm mediaData={dataItem} data={ottAssetPosters} setOttPostersData={setOttPostersData} selectedLanguage={props.selectedLanguage} />
                  </TabPanel>
                  <TabPanel value={"3"} style={{ marginLeft: -30, marginRight: -30, marginBottom: -10 }}>
                    <OttSubtitleForm ottSubtitleData={ottSubtitleData} handleSubtitleData={handleSubtitle} />
                  </TabPanel>

                  {showPublishingTab && OttAssetTypeSID == ASSETTYPE["Media Asset"] && <TabPanel value={"4"}>
                    <MediaEpisodePublishingEditForm
                      showLinearTab={false}
                      mediaCategory={{ isLong: true }}
                      mediaEpisodeEntity={selectedMedia}
                      publishingSource={PUBLISHING_SOURCE.MediaEpisode}
                      data={props.mediaEpisodePublishings}
                      handlePublishings={handleMediaPublishingData}
                      handleRemovePublishingData={handleRemovePublishingData}

                      mediaOfferData={props.mediaEpisodeOffers}
                      handleOffers={handleMediaOfferData}
                      handleRemoveOfferData={handleRemoveOfferData}

                      openPublishingDialog={openPublishingDialog}
                      setOpenPublishingDialog={setOpenPublishingDialog}
                      defaultDealRight={defaultDealRight}
                      isNewMedia={false}
                      dialogtTitle={publishingDialogTitle}
                    />
                  </TabPanel>}

                  {/* {OttAssetTypeSID == ASSETTYPE["Media Asset"] && selectedMedia && selectedMedia.MediaCategory && selectedMedia.MediaCategory.isLong && <TabPanel value={"4"}>
                    <MediaEpisodePublishingEditForm mediaCategory={{ isLong: false }} mediaEpisodeEntity={selectedMedia} publishingSource={PUBLISHING_SOURCE.MediaEpisode} data={mediaEpisodePublishings} handlePublishings={handleMediaPublishingData} handleRemovePublishingData={handleRemovePublishingData} openPublishingDialog={openPublishingDialog} setOpenPublishingDialog={setOpenPublishingDialog} defaultDealRight={defaultDealRight} isNewMedia={!isEdit} dialogtTitle={publishingDialogTitle} />
                  </TabPanel>} */}

                </TabContext>
              </Box>
            </div>

          </div>}

        </>}
      </div>

      {mediaOpen && <ContractCollectionSelection addButtonTitle={lang.select_button_text} title={lang.media_library_dialog_header} wherestatement={['MediaCategory.isLong', '=', true]} setDataList={handleMediaSelect} entityname={ENTITYNAME.MediaEpisode} closeForm={() => setMediaOpen(false)} mode={'single'} width={"50vw"} />}
      {jobsCollectionOpen && <BossDialog title={`Jobs`} onClose={() => setJobsCollectionOpen(false)} width="80vw" height="95vh">
        <Collection entityname={ENTITYNAME.OttTranscodeStatus} showAdd={false} showTitle={false} showBack={false} title={lang.jobs_page_breadcrumb} wherestatement={['AssetId', '=', props.sourceEntity.AssetId]} customEditForm={JobsShowForm} menuModel={collectionJobsMenuModel} />
      </BossDialog>}
      {showJobCollection && <CollectionSelection title={lang.select_playback_url_header} setDataList={handleJobData} entityname={ENTITYNAME.OttTranscodeStatus} closeForm={() => setShowJobCollection(false)} mode={'single'} width={"50vw"} />}
      {showWebAssets && <CollectionSelection wherestatement={["Archive", "=", false]} title={lang.select_web_assets_dialog_header} entityname={ENTITYNAME.WebAssets} setDataList={handleSeletedWebAssets} closeForm={() => setShowWebAssets(false)} width="730px" mode="single" />}
      {
        posterDimensionPageOpen &&
        <BossDialog
          title={lang.poster_dimension_title_label}
          onClose={onClosedPosterDimensionPage}
          width={"20vw"}

        >
          <div className="row ml-1" style={{ textAlign: "center" }}>
            <div className="ml-4 mr-4" style={{ fontWeight: "700", fontSize: "14px" }}>
              <div className="row mb-2">{lang.hero_banner_mobile_label} :</div>
              <div className="row  mb-2">{lang.hero_banner_tv_label} :</div>
              <div className="row  mb-2">{lang.square_label} :</div>
              <div className="row  mb-2">{lang.circle_label} :</div>
              <div className="row  mb-2">{lang.landscape_label} :</div>
            </div>
            <div className="ml-4" style={{ fontWeight: "500" }}>
              <div className="row  mb-2">1280 * 720 PX</div>
              <div className="row  mb-2">1280 * 360 px</div>
              <div className="row  mb-2">512 * 512 PX</div>
              <div className="row  mb-2">512 * 512 PX</div>
              <div className="row  mb-2">328 * 185 PX</div>
            </div>
          </div>
        </BossDialog>
      }
      {musicOpen && <CollectionSelection addButtonTitle={lang.select_button_text} title={lang.music_library_dialog_header} wherestatement={[['MediaCategory.SID', '=', MEDIACATEGORIES.Music], ['IsBreak', '!=', true]]} setDataList={(data) => handleMediaSelect(data, { Description: ENTITYNAME.MediaEpisode })} entityname={ENTITYNAME.MediaEpisode} closeForm={() => setMusicOpen(false)} mode={'single'} width={"50vw"} />}
    </>
  )
};

export default memo(MediaEpisodeAssetEditForm);